export default {
  judgment: '判案书',
  corrigendum: '勘误',
  case: '判案书',
  casename: '案件名称',
  others: '法律相关文件',
  dbs: '资料库',
  indivDbs: '個別资料库',
  toc: '目录',
  toc_short: '目录',
  cright: '版权',
  lang: "语言",
  sortby: "排序方式",
  relevance: "相关性",
  citfreq: '引文次数',
  date: '日期',
  title: '文件标题',
  captitle: '法例标题',
  startdate: '开始日期',
  enddate: '结束日期',
  daterange: "日期范围",
  cap: "章号",
  capno: "法例章号",
  searchresults_status: "状态",
  search_toadv: "使用进阶搜寻以获得更精确的结果",
  search_max_reached: "我们只提供了最相关的{0}项结果",
  action: '案件号码',
  pd: '实务指示',
  pd_num: '号码',
  case_a: '案件',
  appeal: '上诉',
  appealhis: '查询{0}记录',
  appealhistitle: '案件 {1} 的{0}记录',
  wdg_relatedcap: '相关',
  wdg_relatedcap_nil: '此条例没有相关的附属法例',
  wdg_status: '更新状态',
  wdg_status_filecount: '文件总数',
  wdg_status_judcount: '判决书总数',
  wdg_status_dbcount: '资料库数',
  wdg_status_fileunit: '件',
  wdg_status_updatetime: '更新时间',
  wdg_status_foundCount: '条目数量',
  wdg_download: '下载',
  wdg_viewops: '阅读选项',
  wdg_viewops_trans: '此文件没有译本.',
  wdg_jdg: '此判决书资料',
  wdg_jdg_neutral: '通用编号',
  wdg_jdg_pcit: '判例引文',
  wdg_legis: '此法例资料',
  wdg_legis_info: '资料',
  wdg_legis_vercount: '版本数量',
  wdg_legis_latest: '目前版本',
  wdg_legis_enact: '生效日期',
  wdg_treaty: '此公約资料',
  wdg_treaty_cat: '分类',
  wdg_treaty_body: '组织',
  wdg_goto: '查阅官方资料库',
  wdg_goto_elegis: '电子版香港法例 （e-Legislation）',
  wdg_goto_elegis_tooltip: '于香港官方资料库查看此法例',
  wdg_doc: '此文件资料',
  wdg_lang: '语言版本选择',
  wdg_ref_s: '引述此章号的文件',
  wdg_ref_d: '引述此公文的文件',
  wdg_ref_l: '引述此法例的文件',
  wdg_ref_c: '引述此判案书的文件',
  wdg_ref_lawcite: '搜索引用此文件的其他文件及此文件引用过的文件',
  wdg_ref_lawcite_legis: '搜索引用此文件的其他文件及此文件引用过的文件',
  wdg_ref_noteup: '搜索引用此文件的其他文件',
  wdg_ref_noteup_legis: '搜索引用此文件的其他文件',
  wdg_contents: '本页目录',
  wdg_translation: '翻译本',
  wdg_judgment_tag: '相关概念',
  warning: '注意',
  pastver: '这是过去版本，最新情况请见现行版本。',
  compareversion: '请选择版本以作对照',
  compare_explanation: '各版本的不同部分已用颜色标识。',
  compare_diff: '已选择版本没有差异。',
  compare: '对照',
  version: '版本',
  compare_title: '法例版本对照',
  filter: '筛选',
  filter_to: '至',
  filter_and: '与',
  totip_preSec: '上一章',
  totip_nextSec: '下一章',
  loading: '载入中…',
  rsidetitle: '有关此页的资讯',
  fullsection: '本法例内容一览',
  legisdb_filter_hint: '点击分类套用或取消',
  togglehl_hint: '点击开关搜索词高亮',
}